// removed by extract-text-webpack-plugin
module.exports = {"button":"button__button__2qdqP","button-filled":"button__button-filled__3ltTk button__button__2qdqP","button-outline":"button__button-outline__1oObX button__button__2qdqP","button-disabled":"button__button-disabled__1I4BR button__button__2qdqP","purple":"button__purple__pTPNh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/button.scss
// module id = 1195
// module chunks = 1